import VelavuAPIAlerts from "./velavu-api-alerts";
import VelavuAPIAPITokens from "./velavu-api-api-tokens";
import VelavuApiAssetRoutes from "./velavu-api-asset-routes";
import VelavuAPIAssets from "./velavu-api-assets";
import VelavuAPIAuthorizeMQTT from "./velavu-api-authorize-mqtt";
import VelavuAPIBackends from "./velavu-api-backends";
import VelavuAPIDFU from "./velavu-api-dfu";
import VelavuAPIEvents from "./velavu-api-events";
import VelavuAPIGeofences from "./velavu-api-geofences";
import VelavuAPIInvoices from "./velavu-api-invoices";
import VelavuAPIOrganizations from "./velavu-api-organizations";
import VelavuAPIRules from "./velavu-api-rules";
import VelavuAPISiteFloors from "./velavu-api-site-floors";
import VelavuAPISites from "./velavu-api-sites";
import VelavuAPIUsers from "./velavu-api-users";
import VelavuAPIDevices from "./velavu-api-devices";
import VelavuAPIDeviceModels from "./velavu-api-device-models";
import VelavuAPIIntegrations from "./velavu-api-integrations";
export const VelavuAPI = {
    alerts: new VelavuAPIAlerts(),
    apiTokens: new VelavuAPIAPITokens(),
    assetRoutes: new VelavuApiAssetRoutes(),
    assets: new VelavuAPIAssets(),
    devices: new VelavuAPIDevices(),
    authorizeMQTT: new VelavuAPIAuthorizeMQTT(),
    backends: new VelavuAPIBackends(),
    dfu: new VelavuAPIDFU(),
    events: new VelavuAPIEvents(),
    geofences: new VelavuAPIGeofences(),
    invoices: new VelavuAPIInvoices(),
    organizations: new VelavuAPIOrganizations(),
    rules: new VelavuAPIRules(),
    siteFloors: new VelavuAPISiteFloors(),
    sites: new VelavuAPISites(),
    users: new VelavuAPIUsers(),
    deviceModels: new VelavuAPIDeviceModels(),
    integrations: new VelavuAPIIntegrations(),
};
//# sourceMappingURL=velavu-api.js.map